import { createPatchEndpoint } from '@sonar-software/sonar-http';

export type PatchInitiativeTaskRequest = {
	assignedTo?: number;
	initiativeId: number;
	taskId: number;
	completed?: boolean;
	name?: string;
};

export const patchInitiativeTask = createPatchEndpoint<PatchInitiativeTaskRequest>(
	({ initiativeId, taskId }) => `/api/v3/initiatives/${initiativeId}/tasks/${taskId}`,
	{
		requestTransform: ({ initiativeId, taskId, ...rest }) => rest
	}
);
